//available subjects
export const BUSINESS_ALL = 'business_all'
export const BUSINESS_MYAPPROVAL = 'business_myapproval' // approval
export const BUSINESS_COMPANY = 'business_company' // setting
export const BUSINESS_WITHDRAWAL = 'business_withdrawal' // withdrawal
export const BUSINESS_TRANSACTION_PURCHASE = 'business_transaction_purchase' // trxBuy
export const BUSINESS_TRANSACTION_SELL = 'business_transaction_sell' // trxSell
export const BUSINESS_TOPUP = 'business_topup' // topUp
export const BUSINESS_TALANGIN = 'business_talangin' // talanginInvoice
export const BUSINESS_FARMERS = 'business_farmers' // farmers
export const BUSINESS_AUTOREPO = 'business_autorepo' // autoRepo
export const BUSINESS_VESSELS = 'business_vessels' // vessel
export const BUSINESS_WHISTLEBLOWING = 'business_whistleblowing' // whistle blowing
export const BUSINESS_TRIPS = 'business_trips' // trips
export const BUSINESS_WAREHOUSE = 'business_warehouse' //warehouse
export const BUSINESS_INVENTORY = 'business_inventory' //inventory
export const BUSINESS_ATTENDANCE_INPUT = 'business_attendance_input' //attendance
export const BUSINESS_MUTATION_REPORT = 'business_mutation_report'
export const BUSINESS_TRANSFER_INVENTORY = 'business_inventory_transfer' // transfer inventory
export const BUSINESS_MEMBER_DISTRIBUTION = 'business_member_distribution' // member distribution (persebaran anggota)
export const BUSINESS_BOOKKEEPING = 'business_bookkeeping' // arus kas
export const BUSINESS_BOOKKEEPING_COMPANY = 'business_bookkeeping_company' // arus kas company
export const BUSINESS_AR_AP = 'business_ar_ap' // utang piutang
export const BUSINESS_LEARNING_REPORT = 'business_learning_report' // learning report
export const BUSINESS_LEARNING = 'business_learning' // learning
export const BUSINESS_INVENTORY_MEMBER = 'business_member_inventory' // INVENTORI MEMBER
export const BUSINESS_HARVEST = 'business_harvest' // panen
export const BUSINESS_ATTENDANCE_DASHBOARD = 'business_attendance_dashboard'
export const BUSINESS_FULFILMENT = 'business_fulfilment' // fullfillment
export const BUSINESS_PRODUCTION_UNIT = 'business_production_unit' // production unit
export const BUSINESS_MEMBER_PRODUCTION_UNIT = 'business_member_production_unit' // member production unit
export const BUSINESS_COMPLIANCE_DASHBOARD = 'business_compliance_dashboard' // compliance dashboard
export const BUSINESS_GRIEVANCE = 'business_grievance' // grievance
export const BUSINESS_EVENT = 'business_event' // event
export const BUSINESS_EVENT_PARTNER = 'business_event_partner' // event partner
export const BUSINESS_EVENT_PARTICIPANT = 'business_event_participant' // event participant
export const BUSINESS_PROCESS = 'business_item_process' // process
export const BUSINESS_ATTENDANCE_CENTER = 'business_attendance_center'
export const BUSINESS_AR_AP_COMPANY = 'business_ar_ap_company' // ar ap company

export const ALL = 'all'
export const ABILITIES = [
  ALL,
  BUSINESS_COMPANY,
  BUSINESS_WITHDRAWAL,
  BUSINESS_TRANSACTION_PURCHASE,
  BUSINESS_TRANSACTION_SELL,
  BUSINESS_TOPUP,
  BUSINESS_TALANGIN,
  BUSINESS_FARMERS,
  BUSINESS_VESSELS,
  BUSINESS_WHISTLEBLOWING,
  BUSINESS_TRIPS,
  BUSINESS_WAREHOUSE,
  BUSINESS_INVENTORY,
  BUSINESS_TRANSFER_INVENTORY,
  BUSINESS_MEMBER_DISTRIBUTION,
  BUSINESS_BOOKKEEPING,
  BUSINESS_AR_AP,
  BUSINESS_LEARNING_REPORT,
  BUSINESS_LEARNING,
]

// Available actions
export const READ = 'read'
export const UPDATE = 'update'
export const MANAGE = 'manage'
export const MAKE = 'make'
export const CREATE = 'create'

export const ACTIONS = [READ, UPDATE, MANAGE, MAKE]

// Pages private use value snake case ^^
export const APPROVAL_SAYA = 'approval_saya'
export const FORGET_PASSWORD = 'forget_password'
